import {
    type ValidationErrors,
    type ValidatorFn,
    FormGroup,
    type AbstractControl,
    FormArray,
    FormRecord,
} from '@angular/forms';

type Controls = Record<string, AbstractControl> | Record<string, any>;

export class UtilityValidator {
    public static atLeastOne<T extends Controls>(
        validator: ValidatorFn,
        controlFields: (keyof T & string)[] = []
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control instanceof FormGroup || control instanceof FormArray || control instanceof FormRecord) {
                if (!control.controls) {
                    return null;
                }

                const controls: Controls = control.controls;
                const hasAtLeastOne: boolean = controlFields.some((key) => !validator(controls[key]));

                if (hasAtLeastOne) {
                    return null;
                }

                controlFields.forEach((key) => {
                    controls[key].setErrors({ atLeastOne: true });
                });

                return { atLeastOne: true };
            } else {
                return null;
            }
        };
    }
}
